import React from "react";
import s from "./Logo.module.scss"
import logo from "../common/images/appLogo.png"


export function Logo(){
    return <img src={logo} alt="logo"/>
}